import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';

export default function LinkedinIcon({ fill, icon = '#FFF' }) {
    return (
        <SvgIcon sx={{ width: { xs: 44, md: 48 }, height: { xs: 44, md: 48 } }}>
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="48" height="48" rx="8" fill={fill} />
                <mask
                    id="mask0_20418_8246"
                    style={{ maskType: 'alpha' }}
                    maskUnits="userSpaceOnUse"
                    x="8"
                    y="8"
                    width="32"
                    height="32"
                >
                    <rect x="8" y="8" width="32" height="32" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_20418_8246)">
                    <path
                        d="M19.7733 31.1714V20.9347H16.21V31.1714H19.7733ZM17.9924 19.5373C19.2347 19.5373 20.0082 18.7512 20.0082 17.7689C19.9849 16.7641 19.2347 16 18.016 16C16.7965 16 16 16.7641 16 17.7688C16 18.7511 16.7732 19.5372 17.9691 19.5372L17.9924 19.5373ZM21.7456 31.1714H25.3086V25.4554C25.3086 25.1499 25.3319 24.8435 25.426 24.6253C25.6835 24.0137 26.2698 23.3807 27.2543 23.3807C28.5434 23.3807 29.0593 24.3194 29.0593 25.6957V31.1714H32.6222V25.302C32.6222 22.1578 30.8646 20.6947 28.5203 20.6947C26.5983 20.6947 25.7542 21.7205 25.2852 22.4192H25.3089V20.935H21.7458C21.7923 21.8954 21.7456 31.1714 21.7456 31.1714Z"
                        fill={icon}
                    />
                </g>
            </svg>
        </SvgIcon>
    );
}
